import { http } from '@/http/axios.js';

// 列表
export function getkfUserListAPI(params) {
  return http({
    url: '/admin/kf/user/list',
    method: 'get',
    params
  })
}

// 修改接单状态
export function editKfOrderStatusAPI(data) {
  return http({
    url: '/admin/kf/takeOrderStatus/edit',
    method: 'post',
    data
  })
}
